import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQuery } from './baseApi';

const dataBaseQuery = createBaseQuery('https://s3.ts1cloud.com/service3/');

export const dataApi = createApi({
  reducerPath: 'dataApi',
  baseQuery: dataBaseQuery,
  tagTypes: ['RemoteAlertGroups'],
  endpoints: (builder) => ({
    getRemoteAlertGroups: builder.query<any, void>({
      query: () => ({
        url: 'remote-alert-groups',
        method: 'GET',
      }),
      providesTags: ['RemoteAlertGroups'],
    }),
    addRemoteAlertGroup: builder.mutation<any, any>({
      query: (group) => ({
        url: 'remote-alert-groups',
        method: 'POST',
        body: group,
      }),
      invalidatesTags: ['RemoteAlertGroups'],
    }),
    deleteRemoteAlertGroup: builder.mutation<any, number>({
      query: (id) => ({
        url: `remote-alert-groups/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['RemoteAlertGroups'],
    }),
  }),
});

export const { useGetRemoteAlertGroupsQuery, useDeleteRemoteAlertGroupMutation, useAddRemoteAlertGroupMutation } = dataApi; 